module.exports = __webpack_public_path__ + "img/anguilla.2f39428.webp";